import React from "react";

interface AddressLinkProps {
  address: string;
  service: "google" | "apple" | "waze";
  className?: string;
}

function AddressLink({ address, service, className }: AddressLinkProps) {
  const encodedAddress = encodeURIComponent(address);

  let url = "";
  switch (service) {
    case "google":
      url = `https://www.google.com/maps/search/?api=1&query=${encodedAddress}`;
      break;
    case "apple":
      url = `maps://?q=${encodedAddress}`;
      break;
    case "waze":
      url = `https://www.waze.com/ul?q=${encodedAddress}`;
      break;
    default:
      break;
  }

  return (
    <a href={url} target="_blank" rel="noopener noreferrer" className={className}>
      {address}
    </a>
  );
}

export default AddressLink;
